import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable } from 'rxjs';
@Injectable({
  providedIn: 'root'
})
export class ComponentTemplateService {
  private onpageUpdatedSub: BehaviorSubject<string> = new BehaviorSubject<string>('');

  public onpageUpdatedObs: Observable<string>;

  constructor() {
    this.onpageUpdatedObs = this.onpageUpdatedSub.asObservable();
  }

  /**
   * Query documents
   *
   * @param query
   */

  public updateTemplateMenu(pageTitle: string) {
    this.onpageUpdatedSub.next(pageTitle);
  }

  public onMenuItemUpdated() {
    return this.onpageUpdatedObs;
  }
}
